import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/PublicNav";

function GoogleButton() {
  const go = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirect = `${window.location.origin}/auth/callback`;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;
  };
  return (
    <button type="button" className="btn btn-outline w-full" onClick={go} data-testid="google-auth-btn">
      <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.9 29.3 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.5 6.1 29.5 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.3-.4-3.5z"/><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.5 6.1 29.5 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/><path fill="#4CAF50" d="M24 44c5.2 0 10-2 13.6-5.2l-6.3-5.3C29.2 35 26.7 36 24 36c-5.3 0-9.7-3.1-11.3-7.6l-6.5 5C9.6 39.6 16.2 44 24 44z"/><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.1-4 5.5l6.3 5.3C41.9 35.4 44 30.1 44 24c0-1.3-.1-2.3-.4-3.5z"/></svg>
      Continue with Google
    </button>
  );
}

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  useEffect(() => { if (user) nav("/app"); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) nav("/app"); else setError(res.error);
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between p-12 dk-raised border-r">
        <Logo />
        <div>
          <h2 className="font-serif text-[32px] font-semibold">Welcome back.</h2>
          <p className="mt-2 max-w-sm" style={{ color: "var(--text-muted)" }}>Pick up right where you left off — your saved decodes and profiles are waiting.</p>
        </div>
        <span className="text-xs" style={{ color: "var(--text-muted)" }}>Guidance, not therapy. Parent-only.</span>
      </div>
      <div className="grid place-items-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm space-y-4" data-testid="login-form">
          <div className="lg:hidden mb-4"><Logo /></div>
          <h1 className="font-serif text-[28px] font-semibold">Log in</h1>
          {error && <div className="rounded-xl p-3 text-sm" style={{ background: "#F3DEDA", color: "var(--error)" }} data-testid="login-error">{error}</div>}
          <GoogleButton />
          <div className="flex items-center gap-3 text-xs" style={{ color: "var(--text-muted)" }}><span className="flex-1 border-t" /> or <span className="flex-1 border-t" /></div>
          <div>
            <label className="text-sm font-medium">Email</label>
            <input className="dk-input mt-1" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" />
          </div>
          <div>
            <label className="text-sm font-medium">Password</label>
            <input className="dk-input mt-1" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" />
          </div>
          <button className="btn btn-primary w-full" disabled={loading} data-testid="login-submit">{loading && <Loader2 size={16} className="animate-spin" />} Log in</button>
          <p className="text-sm text-center"><Link className="link" to="/auth/forgot" data-testid="forgot-link">Forgot your password?</Link></p>
          <p className="text-sm text-center" style={{ color: "var(--text-muted)" }}>New here? <Link className="link" to="/auth/signup">Start your free trial</Link></p>
        </form>
      </div>
    </div>
  );
}
